/**
 * Expand OrderType branches + mock Go data for admin iframes only.
 * Never use on Apply / persisted content.
 */

import { getPreviewMockOrder } from "../constants/previewMockOrder";
import { resolveOrderTypeBranchesForPreview } from "./themeTokens";
import { resolvePreviewMockData } from "./resolvePreviewMockData";

/**
 * @param {string} html themed or raw notification content
 * @param {{ orderType?: 'DELIVERY' | 'PICKUP', store?: object }} [options]
 * @returns {string}
 */
export function prepareEmailHtmlForAdminPreview(
    html,
    { orderType = "DELIVERY", store } = {},
) {
    if (!html) return "";
    const withOrderType = resolveOrderTypeBranchesForPreview(html, orderType);
    return resolvePreviewMockData(
        withOrderType,
        getPreviewMockOrder({ store }),
    );
}
